import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAllProperties = async () => {
  /**
   * input: null
   * output: properties object
  description: fetches All properties
   */
  try {
    const PropertiesCollection = await collection(db, "properties");

    let q = query(
      PropertiesCollection,
      where("bid", "==", getLocalStorageItem("bid"))
    );

    const PropertiesSnapshot = await getDocs(q);
    let Properties = [];
    PropertiesSnapshot.forEach((e) =>
      Properties.push({ ...e.data(), id: e.id })
    );
    return Properties;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export default GetAllProperties;
